import { AvailableProcedures } from 'apollo/types';
import { Leaf, CivilInstitution, Permit, Tag, Insurance } from 'assets/icons';

export interface ProcedureInfo {
  name: string;
  icon: string;
  key: AvailableProcedures;
  selected: boolean;
  disabled: boolean;
  price: number;
  exceptionMessage?: string;
}

const baseProceduresInfo: ProcedureInfo[] = [
  {
    name: 'Impuesto verde',
    icon: Leaf,
    key: AvailableProcedures.GreenTax,
    selected: false,
    disabled: false,
    price: 0,
  },
  {
    name: 'Inscripción Registro Civil',
    icon: CivilInstitution,
    key: AvailableProcedures.CivilRegistration,
    selected: false,
    disabled: false,
    price: 0,
  },
  // {
  //   name: 'Inscripción Registro Civil - Placas',
  //   icon: CivilInstitution,
  //   key: AvailableProcedures.CivilRegistrationPlate,
  //   selected: false,
  //   disabled: false,
  //   price: 23490,
  // },
  // {
  //   name: 'Prohibición de enajenar',
  //   icon: ProhibitionOfAlienating,
  //   key: AvailableProcedures.ProhibitionOfAlienating,
  //   selected: false,
  //   disabled: false,
  //   price: 0,
  //   exceptionMessage:
  //     'El cobro de la prohibición de enajenar es obligatorio para la opción de pago con financiamiento.',
  // },
  {
    name: 'Seguro obligatorio (SOAP)',
    icon: Insurance,
    key: AvailableProcedures.ObligatoryInsurance,
    selected: false,
    disabled: false,
    price: 0,
  },
  {
    name: 'Permiso de circulación',
    icon: Permit,
    key: AvailableProcedures.CirculationPermit,
    selected: false,
    disabled: false,
    price: 0,
    exceptionMessage:
      'Para seleccionar el permiso de circulación debes seleccionar primero el SOAP.',
  },
  {
    name: 'Inscripción del TAG',
    icon: Tag,
    key: AvailableProcedures.Tag,
    selected: false,
    disabled: false,
    price: 0,
  },
  {
    name: 'Revisión técnica',
    icon: Tag,
    key: AvailableProcedures.VehicleInspection,
    selected: false,
    disabled: false,
    price: 0,
  },
  // {
  //   name: 'Notaría',
  //   icon: Tag,
  //   key: AvailableProcedures.Notary,
  //   selected: false,
  //   disabled: false,
  //   price: 10000,
  // },
  // {
  //   name: 'Gastos administrativos',
  //   icon: Tag,
  //   key: AvailableProcedures.AdministrativeExpenses,
  //   selected: false,
  //   disabled: false,
  //   price: 88071,
  // },
];

export default baseProceduresInfo;
